import { SuperAdminGuard } from "@/components/guards/SuperAdminGuard";
import { AdminLayoutWithAuth } from "@/components/layout/AdminLayout/AdminLayout";
import { LoginLayout } from "@/components/layout/LoginLayout/LoginLayout";
import { SessionLayoutWithAuth } from "@/features/session/layout/SessionLayout";
import SystemSettingLayout from "@/features/system-settings/layout/SystemSettingLayout";
import CognitoAuthCallback from "@/pages/auth/CognitoAuthCallback";
import AuthCallback from "@/pages/auth/AuthCallback";
import MintOauthRedirect from "@/pages/mint-oauth-redirect/MintOauthRedirect";
import OrganizationSelect from "@/pages/session/OrganizationSelect";
import UserSelect from "@/pages/session/UserSelect";
import UserLoginVerify from "@/pages/session/UserLoginVerify";
import UserFirstLogin from "@/pages/session/UserFirstLogin";
import Login from "@/pages/auth/Login";
import LoginVerify from "@/pages/auth/LoginVerify";
import Logout from "@/pages/auth/Logout";
import Recover from "@/pages/auth/Recover";
import RecoverSuccess from "@/pages/auth/RecoverSuccess";
import Register from "@/pages/auth/Register";
import RegisterSuccess from "@/pages/auth/RegisterSuccess";
import ResetPassword from "@/pages/auth/ResetPassword";
import ResetPasswordSuccess from "@/pages/auth/ResetPasswordSuccess";
import OrganizationCreate from "@/pages/organizations/OrganizationCreate";
import OrganizationCreateSetup from "@/pages/organizations/OrganizationCreateSetup";
import OrganizationDetail from "@/pages/organizations/OrganizationDetail";
import OrganizationEdit from "@/pages/organizations/OrganizationEdit";
import OrganizationUserCreate from "@/pages/organizations/OrganizationUserCreate";
import OrganizationUserEdit from "@/pages/organizations/OrganizationUserEdit";
import OrganizationList from "@/pages/organizations/OrganizationList";
import PageNotFound from "@/pages/PageNotFound";
import ServerErrorPage from "@/pages/ServerErrorPage";
import AdminUserCreate from "@/pages/system-settings/admin-users/AdminUserCreate";
import AdminUserDetail from "@/pages/system-settings/admin-users/AdminUserDetail";
import AdminUserList from "@/pages/system-settings/admin-users/AdminUserList";
import AdminUserEdit from "@/pages/system-settings/admin-users/AdminUserEdit";
import MasterDataDetail from "@/pages/master-data/MasterDataDetail";
import MasterDataList from "@/pages/master-data/MasterDataList";
import MasterDataProductCreate from "@/pages/master-data/product/MasterDataProductCreate";
import MasterDataProductEdit from "@/pages/master-data/product/MasterDataProductEdit";
import Maintenance from "@/pages/system-settings/Maintenance";
import Notification from "@/pages/system-settings/Notification";
import { AppRoutes } from "@/routes/config";
import { Navigate, RouteObject } from "react-router-dom";

export const routes: RouteObject[] = [
  {
    element: <LoginLayout />,
    children: [
      {
        path: AppRoutes.recover,
        element: <Recover />,
      },
      {
        path: AppRoutes.recoverSuccess,
        element: <RecoverSuccess />,
      },
      {
        path: AppRoutes.resetPassword,
        element: <ResetPassword />,
      },
      {
        path: AppRoutes.resetPasswordSuccess,
        element: <ResetPasswordSuccess />,
      },
      {
        path: AppRoutes.login,
        element: <Login />,
      },
      {
        path: AppRoutes.loginVerify,
        element: <LoginVerify />,
      },
      {
        path: AppRoutes.authCallback,
        element: <AuthCallback />,
      },
      {
        path: AppRoutes.register,
        element: <Register />,
      },
      {
        path: AppRoutes.registerSuccess,
        element: <RegisterSuccess />,
      },
    ],
  },
  {
    path: AppRoutes.authCallbackCognito,
    element: <CognitoAuthCallback />,
  },
  {
    path: AppRoutes.logout,
    element: <Logout />,
  },
  {
    path: AppRoutes.mintOauthRedirect,
    element: <MintOauthRedirect />,
  },
  {
    element: <SessionLayoutWithAuth />,
    children: [
      {
        path: AppRoutes.organizationSelect,
        element: <OrganizationSelect />,
      },
      {
        path: AppRoutes.userSelect,
        element: <UserSelect />,
      },
      {
        path: AppRoutes.userLoginVerify,
        element: <UserLoginVerify />,
      },
      {
        path: AppRoutes.userFirstLogin,
        element: <UserFirstLogin />,
      },
    ],
  },
  {
    element: <AdminLayoutWithAuth />,
    children: [
      {
        path: AppRoutes.home,
        element: <></>,
      },
      {
        path: AppRoutes.organizations,
        element: <OrganizationList />,
      },
      {
        path: AppRoutes.organizationCreate,
        element: <OrganizationCreate />,
      },
      {
        path: AppRoutes.organizationCreateSetup,
        element: <OrganizationCreateSetup />,
      },
      {
        path: AppRoutes.organizationUserCreate,
        element: <OrganizationUserCreate />,
      },
      {
        path: AppRoutes.organizationUserEdit,
        element: <OrganizationUserEdit />,
      },
      {
        path: AppRoutes.organizationEdit,
        element: <OrganizationEdit />,
      },
      {
        path: AppRoutes.organizationDetail,
        element: <OrganizationDetail />,
      },
      {
        element: <SuperAdminGuard />,
        children: [
          {
            path: AppRoutes.masterData,
            element: <MasterDataList />,
          },
          {
            path: AppRoutes.masterDataProductCreate,
            element: <MasterDataProductCreate />,
          },
          {
            path: AppRoutes.masterDataProductEdit,
            element: <MasterDataProductEdit />,
          },
          {
            path: AppRoutes.masterDataDetail,
            element: <MasterDataDetail />,
          },
          {
            path: AppRoutes.systemSettingsAdminUserCreate,
            element: <AdminUserCreate />,
          },
          {
            path: AppRoutes.systemSettingsAdminUserEdit,
            element: <AdminUserEdit />,
          },
          {
            path: AppRoutes.systemSettingsAdminUserDetail,
            element: <AdminUserDetail />,
          },
          {
            path: AppRoutes.systemSettings,
            element: <SystemSettingLayout />,
            children: [
              {
                index: true,
                element: <Navigate to={AppRoutes.systemSettingsAdminUsers} replace />,
              },
              {
                path: AppRoutes.systemSettingsAdminUsers,
                element: <AdminUserList />,
              },
              {
                path: AppRoutes.systemSettingsNotification,
                element: <Notification />,
              },
              {
                path: AppRoutes.systemSettingsMaintenance,
                element: <Maintenance />,
              },
            ],
          },
        ],
      },
    ],
  },
  { path: AppRoutes.serverErrorPage, element: <ServerErrorPage /> },
  { path: "*", element: <PageNotFound /> },
];
